<!-- PaymentSuccessModal.vue -->
<template>
    <b-modal v-model="showModal" title="Payment Failed" ok-only>
      <p>{{ message }}</p>
      <!-- <b-btn @click="closeModal" variant="success">Close</b-btn> -->
    </b-modal>
  </template>
  
  <script>
  export default {
    data() {
      return {
        showModal: false,
        message: ''
      };
    },
    methods: {
      openModal(message) {
        this.message = message
        this.showModal = true;

      },
      closeModal() {
        this.showModal = false;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your component-specific styles here */
  </style>
  